module.exports = __webpack_public_path__ + "static/media/socialTwitter.6947aeb5.svg";